var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dmq-filter-tag",on:{"click":function($event){return _vm.$emit('clear')}}},[_c('span',{staticClass:"dmq-filter-tag__label"},[_vm._t("default")],2),_c('span',{staticClass:"dmq-filter-tag__clear"},[_vm._v(" x ")])])}
var staticRenderFns = []

export { render, staticRenderFns }